import { ComponentRegistry } from '@sg-core/resources/assets/js/libs/component-registry';

export class JlcComponentRegistry extends ComponentRegistry {
  protected getModules(): Record<string, () => Promise<unknown>> {
    return import.meta.glob('/modules/SG/maisons/jlc/src/View/Components/**/*.ts');
  }
}
